import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import FreeLessonModal from '../../../UiComponents/FreeLessonModal/FreeLessonModal';
import { useLocomotiveScroll } from 'react-locomotive-scroll';

import Star from '../../../../svg/star_white.svg';

const HomeFreeLesson = ({ freeLessonData }) => {
  const langToggle = useLanguage;
  const { scroll } = useLocomotiveScroll();
  const [open, setOpen] = React.useState(false);
  function openPopup() {
    setOpen(true);
    scroll.stop();
  }
  function closeModal() {
    setOpen(false);
    scroll.start();
  }

  return (
    <>
      <section className="home__free-lesson" data-scroll-section>
        <div className="content-wrapper">
          <div className="home__free-lesson__wrapper">
            <span className="home__free-lesson__title-wrapper">
              <h2 className="home__free-lesson__title">
                {langToggle(freeLessonData.title_ua, freeLessonData.title_ru)}
              </h2>
            </span>
            <div className="home__free-lesson__button-wrapper">
              <button className="home__free-lesson__button" onClick={openPopup}>
                <Star className="home__free-lesson__button-star" />
                <span className="home__free-lesson__button-title__wrapper">
                  <span className="home__free-lesson__button-title">
                    {langToggle(
                      `Замовити \nбезкоштовне \nзаняття`,
                      `Получить \nбесплатный \nурок`
                    )}
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <FreeLessonModal
        open={open}
        closeModal={closeModal}
        title={langToggle(freeLessonData.title_ua, freeLessonData.title_ru)}
      />
    </>
  );
};

HomeFreeLesson.propTypes = {
  freeLessonData: PropTypes.object,
};

export default HomeFreeLesson;
